import { shallow } from "zustand/shallow";

import { Translate } from "../../hooks/useTranslation";
import useExplorerStore from "../../store/store";
import FundCardGroupedList from "./FundCardGroupedList";
import FundCardList from "./FundCardList";

import Illustration from "../../assets/globe-illustration.png";

const FundsList = () => {
    const { isGrouped, funds, clearFilters, applySearch } = useExplorerStore(
        ({ isGrouped, refinedData: { funds }, clearFilters, applySearch }) => ({
            isGrouped,
            funds,
            clearFilters,
            applySearch,
        }),
        shallow,
    );

    const reset = () => {
        clearFilters();
        applySearch("");
    };

    if (funds.length === 0) {
        return (
            <div className="flex w-full flex-col items-center justify-center px-4 pt-8 sm:pt-12">
                <img
                    src={Illustration}
                    alt="Globe illustration"
                    className="w-3/4 !max-w-md"
                />
                <p className="mt-4 text-center text-xl sm:mt-8">
                    <Translate>Please adjust your search criteria</Translate>
                </p>
                <p className="mt-2 text-center text-base sm:mt-4">
                    <Translate>or</Translate>{" "}
                    <button
                        onClick={reset}
                        className="inline border-none bg-transparent text-base underline"
                    >
                        <Translate>clear filters</Translate>
                    </button>
                </p>
            </div>
        );
    }

    return isGrouped ? <FundCardGroupedList /> : <FundCardList funds={funds} />;
};

export default FundsList;
